
  import { defineComponent, ref, computed, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useI18n } from 'vue-i18n/index';

  export default defineComponent({
    name: 'finance-funds-filter',
    emit: ['type-selected', 'reset'],
    setup(_, { emit }) {
      const { t, te } = useI18n();
      const store = useStore();

      const selectedItems = ref<any>({
        phone: '',
        screen: '',
        propertyCategoryId: '',
      });

      const translate = (text: string) => (te(text) ? t(text) : text);

      const onSubmit = async () => {
        await store.dispatch(
          Actions.UPDATE_FINANCE_FUNDS_FILTER,
          selectedItems.value
        );
        emit('type-selected', selectedItems.value);
      };

      const onReset = async () => {
        selectedItems.value = { screen: '', phone: '', propertyCategoryId: '' };
        await store.dispatch(
          Actions.UPDATE_FINANCE_FUNDS_FILTER,
          selectedItems.value
        );
        emit('reset', selectedItems.value);
      };

      const filter = computed(() => store.getters.getFinanceFundsFilters || {});
      onMounted(async () => {
        await store.dispatch(Actions.GET_ALL_FINANCE_FUND_ASSETS, 'SOURCES');
        if (filter.value?.phone) selectedItems.value.phone = filter.value.phone;
        if (
          filter.value?.propertyCategoryId &&
          filter.value?.propertyCategoryId !== undefined
        )
          selectedItems.value.propertyCategoryId =
            filter.value.propertyCategoryId;
        if (filter.value?.screen && filter.value?.screen !== undefined)
          selectedItems.value.screen = filter.value.screen;
      });

      return {
        selectedItems,
        onSubmit,
        onReset,
        translate,
        propertyTypesCategories: computed(
          () => store.getters.propertyAllCategoryList
        ),
        financeFundAssets: computed(() => store.getters.allFinanceFundAssets),
      };
    },
  });
